// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import axios from "axios";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import VueAxios from "vue-axios";
import DashboardPlugin from "./material-dashboard";

// TODO: Update material-vue to fix error on select input change

// plugin setup
Vue.use(DashboardPlugin);
Vue.material.locale = {
  startYear: 1900,
  endYear: 2099,
  dateFormat: "dd.MM.yyyy",
  days: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  shortDays: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  shorterDays: ["S", "M", "D", "M", "D", "F", "S"],
  months: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  shorterMonths: [
    "Ja",
    "Fe",
    "Mä",
    "Ap",
    "Ma",
    "Jn",
    "Jl",
    "Au",
    "Se",
    "Ok",
    "No",
    "De"
  ],
  firstDayOfAWeek: 0,
  cancel: "Abbrechen",
  confirm: "Übernehmen"
};

Vue.use(VueAxios, axios);

// router & store setup
import router from "./router";
import store from "./store";

// global library setup
Vue.prototype.$Chartist = Chartist;

import { dateFilter } from "vue-date-fns";

Vue.filter("date", dateFilter);
Vue.mixin({
  methods: {
    toIsoDate(date) {
      try {
        if (typeof date === "string") {
          const parts = date.split(".");
          return parts[2] + "-" + parts[1] + "-" + parts[0];
        } else if (typeof date === "object") {
          return dateFilter(date, "yyyy-MM-dd");
        } else {
          return date;
        }
      } catch {
        return date;
      }
    },
    toGermanDate(date) {
      if (date) {
        try {
          return dateFilter(new Date(date), "dd.MM.yyyy");
        } catch (e) {
          return date;
        }
      } else {
        return date;
      }
    },
    dateFilter(date, format) {
      try {
        if (!date) return null;
        return dateFilter(date, format);
      } catch {
        return date;
      }
    },
    getPersonOrganizationLabel(object) {
      if (!object) return "";
      let label = "";

      if (object.name) {
        label += object.name;
      } else {
        if (object.prefix) {
          label += object.prefix + " ";
        }
        if (object.given_name) {
          label += object.given_name + " ";
        }
        if (object.family_name) {
          label += object.family_name;
        }
      }

      return label;
    },
    translateTelecomType(type) {
      switch (type) {
        case "email":
          return "E-Mail";
        case "phone":
          return "Telefon";
        case "fax":
          return "Fax";
      }
    },
    getPaymentLabel(payment_type) {
      switch (payment_type) {
        case "credit-transfer":
          return "Überweisung";
        case "direct-debit":
          return "Lastschrift";
        case "unknown":
          return "Unbekannt";
      }
    },
    hasPermission(permission_name) {
      return (
        this.$store.getters["profile/me"] &&
        this.$store.getters["profile/me"].roles &&
        this.$store.getters["profile/me"].roles.some(role => {
          return role.permissions.some(
            permission => permission.name === permission_name
          );
        })
      );
    },
    floatFormat(number) {
      if (number !== "") {
        return Number.parseFloat(number)
          .toFixed(2)
          .toString()
          .replace(".", ",")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    }
  }
});

/* eslint-disable no-new */
const app = new Vue({
  router: router,
  store: store,
  el: "#app",
  render: h => h(App)
});

store.$app = app;
